import axios from 'axios';
import { baseUrl } from '@/config';
import { downloadFile } from '@/utils/file';
const PREFIX_URL = '/event/kedb/';
export default {
  /**
   * KEDB 목록 조회
   * @author yelim
   */
  getKedbList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-kedb-list.do`, params);
  },
  /**
   * kedb 정보 추가
   * @author yelim
   */
  addKedbInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}add-kedb-info.do`, params);
  },
  /**
   * KEDB 정보 수정
   * @author yelim
   */
  updateKedbInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}update-kedb-info.do`, params);
  },
  /**
   * [getRelationRscList KEDB 목록 태그 필터링을 위한 연관 자원 목록 조회]
   * @author yelim
   */
  getRelationRscList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-relation-rsc-list.do`, params);
  },
  /**
   * 선택한 KEDB 목록을 삭제한다.
   * @author yelim
   */
  deleteKedbInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}delete-kedb-info.do`, params);
  },
  /**
   * KEDB 상세 정보를 조회한다.
   * @author yelim
   */
  getKedbDetailInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-kedb-detail-info.do`, params);
  },
  /**
   * KEDB 추천 수를 증가시킨다.
   * @author yelim
   */
  updateKedbRecommend(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}update-kedb-recommend.do`, params);
  },
  /**
   * KEDB 추가 시 자원 정보 가공을 위해 별도로 요청한다.
   * @author yelim
   */
  getRscInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-rsc-info.do`, params);
  },
  /**
   * KEDB에 첨부된 첨부파일을 다운로드 받는다.
   * @author yelim
   */
  downloadAttachFile(params) {
    downloadFile(`${baseUrl}${PREFIX_URL}download-attach-file.do`, params, 'post');
  },
  /**
   * 장애 조치 추천 내용을 조회한다.
   * @author Ju
   * @param  {Object} params { managetypeId, rsctypeId, rscId, rscKey, searchKeyword  (검색 키워드) }
   * @return {[type]}        [description]
   */
  getRecommendTroubleshooting(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-recommend-troubleshooting.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/event/kedb.js